import { render, staticRenderFns } from "./GainPoints.vue?vue&type=template&id=87d7a91e&scoped=true&"
import script from "./GainPoints.vue?vue&type=script&lang=js&"
export * from "./GainPoints.vue?vue&type=script&lang=js&"
import style0 from "./GainPoints.vue?vue&type=style&index=0&id=87d7a91e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d7a91e",
  null
  
)

export default component.exports